import React from "react";
import { useState, useEffect } from "react";
import UserService from "../../services/user.service";
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Pictures from "./pictures.component";



const IncidentReports = () =>{
    const [ loading, setLoading ] = useState(false)
    const [ rows, setRows ] = useState([])
    const [ dataBackup, setDataBackup] = useState([])
    const [ openPictures, setOpenPictures ] = useState(false)
    const [ picturesLocation, setPicturesLocation ] = useState()
    const [ logCheck, setLogCheck ] = useState(true)
    const columns = [
        { field: 'id', headerName: 'ID', headerClassName: 'table-header', width: 50 },
        {
            field: 'date_of_incident',
            headerName: 'Incident Date',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
           
          },
        {
            field: 'time_of_incident',
            headerName: 'Incident Time',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
        {
          field: 'category_of_person_involved',
          headerName: 'Person Category',
          headerClassName: 'table-header',
          width: 200,
          editable: false,
        },
        {
          field: 'persons_name',
          headerName: 'Name',
          headerClassName: 'table-header',
          width: 200,
          editable: false,
        },
       {
          field: 'address1',
          headerName: 'Address1',
          headerClassName: 'table-header',
          width: 200,
          editable: false,
        },
        {
            field: 'address2',
            headerName: 'Address2',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
        },
        {
            field: 'town',
            headerName: 'Town',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
        },
        {
            field: 'county',
            headerName: 'County',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
        },
        {
            field: 'post_code',
            headerName: 'Post Code',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
        },
        {
            field: 'email_address',
            headerName: 'Email',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
        },
        {
            field: 'phone_no',
            headerName: 'Phone',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
           
          },
          {
            field: 'witness_name',
            headerName: 'Witness Name',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
           
          },
          {
            field: 'witness_address1',
            headerName: 'Witness Address1',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'witness_address2',
            headerName: 'Witness Address2',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'witness_address_town',
            headerName: 'Witness Town',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'witness_address_county',
            headerName: 'Witness County',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'witness_address_post_code',
            headerName: 'Witness Post Code',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'witness_email',
            headerName: 'Witness email',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'witness_contact_number',
            headerName: 'Witness Phone',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'incident_address1',
            headerName: 'Incident Address1',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'incident_address2',
            headerName: 'Incident Address2',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'incident_address_town',
            headerName: 'Incident Town',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'incident_address_county',
            headerName: 'Incident County',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'incident_address_postcode',
            headerName: 'Incident Address1',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'description_of_location',
            headerName: 'Location Description',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'description',
            headerName: 'Incident Description',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'injuries_sustained',
            headerName: 'Injuries',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'details_of_injuries_and_who',
            headerName: 'Details of Injuries',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'additional_information',
            headerName: 'Additional Info',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'follow_up_comments',
            headerName: 'Follow Up Comments',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'updatedBy',
            headerName: 'Uploaded By',
            headerClassName: 'table-header',
            width: 200,
            editable: false,
          },
          {
            field: 'pictures',
            headerName: 'Pictures',
            headerClassName: 'table-header',
            width: 180,
            //editable: true,
            type: 'component',
            renderCell: (params) => (
                <div>{/*<Video params={params} />*/}<button className='buttonVid' onClick={e => openVideo(e, params)}>Open Pictures</button></div>
                
              ),
           
          },
    ]
    useEffect(() =>{
        UserService.getIncidents().then(
            response =>{
                let data = response.data
                let pla =[]
                data?.map(row =>{
                    pla.push({id: row.entry, date_of_incident: row.date_of_incident !== 'undefined' ? row.date_of_incident : '', time_of_incident: row.time_of_incident !== 'undefined' ? row.time_of_incident : '', category_of_person_involved: row.category_of_person_involved !== 'undefined' ? row.category_of_person_involved : '', persons_name: row.persons_name !== 'undefined' ? row.persons_name : '', address1: row.address1 !== 'undefined' ? row.address1 : '', address2: row.address2 !== 'undefined' ? row.address2 : '', town: row.town !== 'undefined' ? row.town : '', county: row.county !== 'undefined' ? row.county : '', post_code: row.post_code !== 'undefined' ? row.post_code : '', email_address: row.email_address !== 'undefined' ? row.email_address : '', phone_no: row.phone_no !== 'undefined' ? row.phone_no : '', witness_name: row.witness_name !== 'undefined' ? row.witness_name : '', witness_address1: row.witness_address1 !== 'undefined' ? row.witness_address1 : '', witness_address2: row.witness_address2 !== 'undefined' ? row.witness_address2 : '', witness_address_town: row.witness_address_town !== 'undefined' ? row.witness_address_town : '', witness_address_county: row.witness_address_county !== 'undefined' ? row.witness_address_county : '', witness_address_post_code: row.witness_address_post_code !== 'undefined' ? row.witness_address_post_code : '', witness_email: row.witness_email !== 'undefined' ? row.witness_email : '', witness_contact_number: row.witness_contact_number !== 'undefined' ? row.witness_contact_number : '', incident_address1: row.incident_address1 !== 'undefined' ? row.incident_address1 : '', incident_address2: row.incident_address2 !== 'undefined' ? row.incident_address2 : '', incident_address_town: row.incident_address_town !== 'undefined' ? row.incident_address_town : '', incident_address_county: row.incident_address_county !== 'undefined' ? row.incident_address_county : '', incident_address_postcode: row.incident_address_postcode !== 'undefined' ? row.incident_address_postcode : '', description_of_location: row.description_of_location !== 'undefined' ? row.description_of_location : '', description: row.description !== 'undefined' ? row.description : '', injuries_sustained: row.injuries_sustained !== 'undefined' ? row.injuries_sustained : '', details_of_injuries_and_who: row.details_of_injuries_and_who !== 'undefined' ? row.details_of_injuries_and_who : '', additional_information: row.additional_information !== 'undefined' ? row.additional_information : '', follow_up_comments: row.follow_up_comments !== 'undefined' ? row.follow_up_comments : '', updatedBy: row.updatedBy !== 'undefined' ? row.updatedBy : '', pictures: row.folder && row.picture_count && row.picture_type ? row.folder+'+'+row.picture_count+'+'+row.picture_type : ''})
                })
                setDataBackup(pla)
                setRows(pla)
            }
        ).catch(err =>{
          if(err.message == "Request failed with status code 403"){
              setLogCheck(false)
          }
        })
    },[])

    const handleSearch = (e) =>{
        let data = rows
        let search = []
        data?.map(row =>{
            if(row.persons_name?.toLowerCase().match(e.target.value?.toLowerCase())){
                search.push({id: row.id, date_of_incident: row.date_of_incident !== 'undefined' ? row.date_of_incident : '', time_of_incident: row.time_of_incident !== 'undefined' ? row.time_of_incident : '', category_of_person_involved: row.category_of_person_involved !== 'undefined' ? row.category_of_person_involved : '', persons_name: row.persons_name !== 'undefined' ? row.persons_name : '', address1: row.address1 !== 'undefined' ? row.address1 : '', address2: row.address2 !== 'undefined' ? row.address2 : '', town: row.town !== 'undefined' ? row.town : '', county: row.county !== 'undefined' ? row.county : '', post_code: row.post_code !== 'undefined' ? row.post_code : '', email_address: row.email_address !== 'undefined' ? row.email_address : '', phone_no: row.phone_no !== 'undefined' ? row.phone_no : '', witness_name: row.witness_name !== 'undefined' ? row.witness_name : '', witness_address1: row.witness_address1 !== 'undefined' ? row.witness_address1 : '', witness_address2: row.witness_address2 !== 'undefined' ? row.witness_address2 : '', witness_address_town: row.witness_address_town !== 'undefined' ? row.witness_address_town : '', witness_address_county: row.witness_address_county !== 'undefined' ? row.witness_address_county : '', witness_address_post_code: row.witness_address_post_code !== 'undefined' ? row.witness_address_post_code : '', witness_email: row.witness_email !== 'undefined' ? row.witness_email : '', witness_contact_number: row.witness_contact_number !== 'undefined' ? row.witness_contact_number : '', incident_address1: row.incident_address1 !== 'undefined' ? row.incident_address1 : '', incident_address2: row.incident_address2 !== 'undefined' ? row.incident_address2 : '', incident_address_town: row.incident_address_town !== 'undefined' ? row.incident_address_town : '', incident_address_county: row.incident_address_county !== 'undefined' ? row.incident_address_county : '', incident_address_postcode: row.incident_address_postcode !== 'undefined' ? row.incident_address_postcode : '', description_of_location: row.description_of_location !== 'undefined' ? row.description_of_location : '', description: row.description !== 'undefined' ? row.description : '', injuries_sustained: row.injuries_sustained !== 'undefined' ? row.injuries_sustained : '', details_of_injuries_and_who: row.details_of_injuries_and_who !== 'undefined' ? row.details_of_injuries_and_who : '', additional_information: row.additional_information !== 'undefined' ? row.additional_information : '', follow_up_comments: row.follow_up_comments !== 'undefined' ? row.follow_up_comments : '', updatedBy: row.updatedBy !== 'undefined' ? row.updatedBy : '', pictures: row.folder && row.picture_count && row.picture_type ? row.folder+'+'+row.picture_count+'+'+row.picture_type : ''})
            }
        })
        if(e.target.value){
            setRows(search)
        }else{
            setRows(dataBackup)
        }
    }

    const openVideo = (e, params) =>{
        setPicturesLocation(params.formattedValue)
        setOpenPictures(true)
    }
    
    const handleClosePictures = () =>{
        setOpenPictures(false)
    }
  
    return(
        <div className="incidentRArch">
            {logCheck ? 
            <>
            <h3 className="h3TitlesCorrection">Incidents</h3>
            <input type="text" name='search' className="inputIncidents" placeholder="search..."/*defaultValue={email}*/  onChange={e => handleSearch(e)}  />

            <Box sx={{ height: 950, width: 1600, paddingLeft: '0%', marginTop: '20px' }}>
                <DataGrid
                
                    // checkboxSelection
                    //onRowSelectionModelChange={params => setSelected(params)}
                    rows={rows}
                    
                    columns={columns}
                    initialState={{
                        pagination: {
                        paginationModel: {
                            pageSize: 100,
                        },
                        },
                    }}
                    sx={{fontSize: '20px', fontFamily: ''}}
                    pageSizeOptions={[100]}
                    //onRowClick={params => handleRow(params)}
                    slots={{
                        loadingOverlay: LinearProgress,
                    }}
                    loading={loading}
                    //{...data}
                    //processRowUpdate={handleCellEdit}
                    //onCellClick={handleClick}
            
                />
            </Box>
            <React.Fragment sx={{overflow: 'visible'}}>
                <Dialog
                    fullScreen
                    
                    open={openPictures}
                    //TransitionComponent={Transition}
                    keepMounted
                    //onClose={handleClose}
                    aria-describedby="alert-dialog-slide-description">
                    <DialogTitle>{}</DialogTitle>
                    <DialogContent >
                        <Pictures source={picturesLocation}/>
                    </DialogContent>
                    <DialogActions>
                        <button className="buttonSS" onClick={handleClosePictures}>Close</button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
            </> :
            <>
                <h3 className="h3TitlesCorrection" style={{color: 'red'}}>You have to be logged in to use this service!</h3>
            </>
            }
        </div>
    )
}
export default IncidentReports;